
    import './styles.scoped.css';
    export default {
  "slider": "awsui_slider_cqzlk_1peu1_145",
  "slider-side": "awsui_slider-side_cqzlk_1peu1_179"
};
  